import { render, staticRenderFns } from "./orderComment.vue?vue&type=template&id=6b039423&scoped=true&"
import script from "./orderComment.vue?vue&type=script&lang=js&"
export * from "./orderComment.vue?vue&type=script&lang=js&"
import style0 from "./orderComment.vue?vue&type=style&index=0&id=6b039423&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b039423",
  null
  
)

export default component.exports